import { render, staticRenderFns } from "./webhook-list-page.vue?vue&type=template&id=02977288&"
import script from "./webhook-list-page.vue?vue&type=script&lang=js&"
export * from "./webhook-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports